module.exports = __webpack_public_path__ + "img/logo.e3606ee1.png";